import { Injectable, NgZone } from '@angular/core';
import { Observable } from 'rxjs';
import { first } from 'rxjs/operators';
import { AJSService, DialogService } from '@app/core/services';
import { FlyoutService } from '@app/core/services/flyout.service';

/**
 * Guards against AJS -> NGX navigation with unsaved changes
 */
@Injectable()
export class AjsNgxGuard {
	constructor(
		private readonly ajsService: AJSService,
		private readonly zone: NgZone,
		private readonly flyoutService: FlyoutService,
		private readonly dialogService: DialogService
	) {}

	canActivate(): Promise<boolean> | Observable<boolean> | boolean {
		const flyout = this.flyoutService.flyout$.value;

		if (flyout) {
			return this.dialogService.canDeactivate(flyout.context);
		}

		return new Promise((resolve) => {
			this.zone.onStable.pipe(first()).subscribe(() => {
				// access $scope of the current controller
				const $scope: any = this.ajsService.currentRoute?.locals?.$scope;
				// standardized method to determine whether a form is dirty: $scope.vm.formIsDirty
				let canActivate = true;
				try {
					const isDirty = $scope?.vm?.formIsDirty?.();
					canActivate = !isDirty;
				} catch (error) {
					// TODO: add DataDog logging once a logging service is available
				}
				resolve(canActivate);
			});
		});
	}
}
